import React from 'react'
import { Box } from '@mui/material'

export const Loader: React.FC = (): JSX.Element => {
  return (
    <Box className="loadingio-spinner-double-ring">
      <Box className="ldio">
        <Box />
        <Box />
        <Box>
          <Box />
        </Box>
        <Box>
          <Box />
        </Box>
      </Box>
    </Box>
  )
}
